module.exports = __webpack_public_path__ + "a1592d9d3306ff06194c4aee577f728f.svg";